export default __webpack_public_path__ + "static/media/stars.120fbc5b.svg";